import React from 'react';
import { useNavigate } from 'react-router-dom';

function About() {
  const navigate = useNavigate();

  const handleMeetTeam = () => {
    navigate('/team');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="relative">
            <div className="hero-image-container">
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop" 
                alt="Our Team" 
                className="w-full rounded-3xl shadow-2xl"
              />
            </div>
            <div className="absolute -bottom-10 -right-10 bg-gradient-to-br from-green-500 to-blue-600 p-8 rounded-2xl text-white">
              <div className="text-4xl font-black mb-2">15+</div>
              <div className="text-lg font-semibold">Years of Excellence</div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="inline-block bg-gray-100 px-6 py-3 rounded-full shadow-sm mb-6">
              <span className="text-green-600 font-semibold">About Us</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-8">
              Innovation Driven by <span className="text-gradient">Passion</span>
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              Founded on the principle that technology should empower businesses, we've been at the forefront of digital transformation for over 15 years. Our team of experts combines deep technical knowledge with creative thinking to solve complex problems.
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center text-green-600">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Customer-Centric Approach</div>
                  <div className="text-gray-600">Your success is our priority</div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Innovative Solutions</div>
                  <div className="text-gray-600">Cutting-edge technologies</div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center text-purple-600">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Proven Expertise</div>
                  <div className="text-gray-600">100+ successful projects</div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center text-yellow-600">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">24/7 Support</div>
                  <div className="text-gray-600">Always here when you need us</div>
                </div>
              </div>
            </div>

            <div className="pt-8">
              <button 
                onClick={handleMeetTeam}
                className="magnetic-btn bg-green-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-600 transition-all shadow-lg hover:shadow-green-500/30 flex items-center justify-center gap-2"
              >
                Meet Our Team
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Marquee Section */}
        <div className="mt-32">
          <div className="marquee-container bg-gray-900 text-white py-8">
            <div className="marquee-content">
              <span className="text-4xl font-black mx-8 tracking-tight">EXCELLENCE</span>
              <span className="text-4xl font-black mx-8 tracking-tight">INNOVATION</span>
              <span className="text-4xl font-black mx-8 tracking-tight">QUALITY</span>
              <span className="text-4xl font-black mx-8 tracking-tight">TRUST</span>
              <span className="text-4xl font-black mx-8 tracking-tight">EXCELLENCE</span>
              <span className="text-4xl font-black mx-8 tracking-tight">INNOVATION</span>
              <span className="text-4xl font-black mx-8 tracking-tight">QUALITY</span>
              <span className="text-4xl font-black mx-8 tracking-tight">TRUST</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;